import CouponSuccessModal from "./coupon-success-modal.component";

export default CouponSuccessModal;
